export const SET_THEME = "SET_THEME"
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE"
export const CHANGE_PATH = "CHANGED_PATH"
export const IS_PREVIEW = "IS_PREVIEW"
export const STREAM_REFRESH = "STREAM_REFRESH"
export const COOKIE_CONSENT = "COOKIE_CONSENT"
